import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../utils/auth";
import { sdkWrapperURL } from "../utils/api-url-list";
import LoadingScreen from "../components/LoadingScreen";
import Male from "../assets/icons/doctor.svg";
import Female from "../assets/icons/nurse.svg";

const MyCareteam = () => {
  const navigate = useNavigate();
  const {
    getToken,
    userData: { profile_id },
  } = useAuth();
  const [loading, setLoading] = useState(true);
  const [teamDetails, setTeamDetails] = useState(undefined);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const token = await getToken();
        const dataResp = await fetch(
          sdkWrapperURL("/users/get-doctor-nurse-info"),
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
            body: JSON.stringify({ pd_id: profile_id }),
          }
        );
        const dataRespJSON = await dataResp.json();
        if (dataRespJSON?.statusCode?.toString().startsWith("2"))
          setTeamDetails({
            doctor: {
              id: dataRespJSON.doctor?.id,
              name: `${dataRespJSON.doctor?.first_name} ${dataRespJSON.doctor?.last_name}`,
              gender: dataRespJSON.doctor?.gender,
            },
            nurse: {
              id: dataRespJSON.nurse?.id,
              name: `${dataRespJSON.nurse?.first_name} ${dataRespJSON.nurse?.last_name}`,
              gender: dataRespJSON.nurse?.gender,
            },
            health_coach:
              dataRespJSON.health_coach?.id?.length > 0
                ? {
                    id: dataRespJSON.health_coach?.id,
                    name: `${dataRespJSON.health_coach?.first_name} ${dataRespJSON.health_coach?.last_name}`,
                    gender: dataRespJSON.health_coach?.gender,
                  }
                : undefined,
            onboarded_on: new Date(dataRespJSON.onboarded_on).toLocaleString(),
            appointments_count: dataRespJSON.appointments_count?.count,
          });
        else throw new Error(dataRespJSON.message);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [getToken, profile_id]);

  const check = async () => {
    setLoading(true);
    try {
      const token = await getToken();
      const dataResp = await fetch(sdkWrapperURL("/auth/refresh-token"), {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify({
          profile_id,
          platform_name: "CAREPLIX_ONE",
          response_platform_name: "CARENOWDOC",
        }),
      });
      const dataRespJSON = await dataResp.json();
      if (dataRespJSON?.statusCode?.toString().startsWith("2")) {
        navigate("/appointments", {
          state: { id: dataRespJSON.id, token: dataRespJSON.token },
        });
      } else throw new Error(dataRespJSON.message);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return loading ? (
    <LoadingScreen style={{ minHeight: "50vh" }} />
  ) : typeof teamDetails === "undefined" ? (
    <div className="px-6 pb-24">
      <div className="flex items-center mb-5">
        <Link to={-1} className="mr-3">
          <svg
            width="6"
            height="10"
            viewBox="0 0 10 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.42402 16.2142C9.99277 15.6454 9.99277 14.7267 9.42402 14.1579L3.76569 8.49959L9.42402 2.84126C9.99277 2.27251 9.99277 1.35376 9.42402 0.785009C8.85527 0.216259 7.93652 0.216259 7.36777 0.785009L0.674024 7.47876C0.105274 8.04751 0.105274 8.96626 0.674024 9.53501L7.36777 16.2288C7.92194 16.7829 8.85527 16.7829 9.42402 16.2142Z"
              fill="#fff"
            />
          </svg>
        </Link>
        <h3 className="text-white text-[14px] font-semibold">My Cayrteam</h3>
      </div>
      <div className="my-3 flex items-center space-x-4 px-6 py-4 rounded-2xl bg-gradient-transparent text-white w-[90%] mx-auto">
        <div>
          <h2 className="text-sm font-bold leading-tight tracking-tight">
            The Team is yet to assign a program to you.
          </h2>
          <p className="mt-1.5 text-xxs leading-tight tracking-tight">
            Please check after some time.
          </p>
        </div>
      </div>
    </div>
  ) : (
    <div className="px-6 pb-24">
      <div className="flex items-center mb-5">
        <Link to={-1} className="mr-3">
          <svg
            width="6"
            height="10"
            viewBox="0 0 10 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.42402 16.2142C9.99277 15.6454 9.99277 14.7267 9.42402 14.1579L3.76569 8.49959L9.42402 2.84126C9.99277 2.27251 9.99277 1.35376 9.42402 0.785009C8.85527 0.216259 7.93652 0.216259 7.36777 0.785009L0.674024 7.47876C0.105274 8.04751 0.105274 8.96626 0.674024 9.53501L7.36777 16.2288C7.92194 16.7829 8.85527 16.7829 9.42402 16.2142Z"
              fill="#fff"
            />
          </svg>
        </Link>
        <h3 className="text-white text-[14px] font-semibold">My Cayrteam</h3>
      </div>
      <div>
        <div className="my-3 flex items-center space-x-4 px-6 py-4 rounded-2xl bg-gradient-transparent text-white w-[90%] mx-auto justify-between">
          <div>
            <h3 className="text-sm font-bold leading-tight tracking-tight">
              Doctor Details
            </h3>
            <p className="mt-1.5 text-xxs leading-tight tracking-tight">
              Name :{teamDetails?.doctor?.name}
            </p>
          </div>
          <img
            className="shrink-0 h-[3.5rem] border-white"
            src={teamDetails.nurse.gender === "male" ? Male : Female}
            alt="doctor"
          />
        </div>
        <div className="my-3 flex items-center space-x-4 px-6 py-4 rounded-2xl bg-gradient-transparent text-white w-[90%] mx-auto justify-between">
          <div>
            <h3 className="text-sm font-bold leading-tight tracking-tight">
              Nurse Details
            </h3>
            <p className="mt-1.5 text-xxs leading-tight tracking-tight">
              Name :{teamDetails?.nurse?.name}
            </p>
            <p className="mt-1.5 text-xxs leading-tight tracking-tight">
              Onboarded On: {teamDetails.onboarded_on}
            </p>
          </div>
          <img
            className="shrink-0 h-[3.5rem]"
            src={teamDetails.nurse.gender === "male" ? Male : Female}
            alt="nurse"
          />
        </div>
        {teamDetails?.health_coach?.name?.length > 0 && (
          <div className="my-3 flex items-center space-x-4 px-6 py-4 rounded-2xl bg-gradient-transparent text-white w-[90%] mx-auto justify-between">
            <div>
              <h3 className="text-sm font-bold leading-tight tracking-tight">
                Health Coach Details
              </h3>
              <p className="mt-1.5 text-xxs leading-tight tracking-tight">
                Name :{teamDetails?.health_coach?.name}
              </p>
            </div>
            <img
              className="shrink-0 h-[3.5rem]"
              src={teamDetails.nurse.gender === "male" ? Male : Female}
              alt="health-coach"
            />
          </div>
        )}

        <div className="my-3 px-6 py-4 rounded-2xl bg-gradient-transparent text-white w-[90%] mx-auto">
          <div className="flex justify-between">
            <h3 className="text-sm font-bold leading-tight tracking-tight">
              Pending Appointment
            </h3>
            <div className="bg-secondary rounded-full w-6 h-6 flex items-center justify-center">
              {teamDetails?.appointments_count ?? 0}
            </div>
          </div>
          <p className="mt-1.5 text-xxs leading-tight tracking-tight">
            Check pending Appointments with your Cayrteam
          </p>
          <button
            className="block w-40 mt-3 ml-auto mr-0 px-4 py-2 rounded-full bg-white text-secondary text-sm text-center font-medium"
            type="button"
            onClick={check}
          >
            Check
          </button>
        </div>
        <Link
          to="/patient-appointment"
          className="my-3 flex items-center space-x-4 px-6 py-4 rounded-2xl bg-gradient-transparent text-white w-[90%] mx-auto justify-between"
        >
          <div>
            <h3 className="text-sm font-bold leading-tight tracking-tight">
              Request Appointment
            </h3>
            <p className="mt-1.5 text-xxs leading-tight tracking-tight">
              Request Appointment with Cayrteam
            </p>
          </div>
          <p className="w-40 px-4 py-2 rounded-full bg-white text-secondary text-sm text-center font-medium">
            Request
          </p>
        </Link>
      </div>
    </div>
  );
};

export default MyCareteam;
